module.exports = __webpack_public_path__ + "static/img/foundation.39f4996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smashing-golden-eggs/foundation.png
// module id = 2GOt
// module chunks = 215